<template>
  <div id="flex"> 
    <div v-for="(light, index) in lightData" :key="light.id" class="lightContainer">
      <Light :appId=light.appId :ref="`light${index}`"></Light>
    </div>
  </div>
</template>

<script>
import Light from './Light.vue'
import firebase from '@/firebase/firestore'

export default {
  name: 'Visualization',
  components: {
    Light
  },
  props: {
  },
  data() {
    return {
      db : null, 
      lightData: [],
      sampleData: [],
      sampleNumber: 0,
      launchedTimestamp: null,
      count: 0,
      // 正規表現
      rNum: new RegExp("^[0-9]"),
      rUpper: new RegExp("^[A-Z]"),
      idHash: {}
    }
  },
  created : function () {
    // dbインスタンスを初期化
    this.db = firebase.firestore(); 

    // sampleデータをlightDataにpushする
    this.makeSampleData();

    // 起動時の現在時刻をセットする
    this.launchedTimestamp = firebase.firestore.Timestamp.now();
    let launchedDate = this.launchedTimestamp.toDate();
    console.log(new Date() + " , " + new Date().getTime() + " :Visualization.vue:: Visualization sets Launched time at " + launchedDate + " ( " + launchedDate.getTime() + " ) / を起動時刻として起動しました！");
  },
  mounted: function () {
    // リアルタイム監視をスタートする
    console.log(new Date() + " , " + new Date().getTime() + " :Visualization.vue:: Starting realtime listener of Firestore / Firestoreのリアルタイムリスナーを開始しました。: ");
    this.realTimeCheck();

    // 連続的にsampleデータを動かす
    this.moveSampleData();
  },
  methods: {
    makeSampleData: function () {
      // 作成するsampledata数をここで決定する
      console.log(new Date()  + " , " + new Date().getTime() +  " :Visualization.vue:: Begin to generate sample Data / サンプルデータを生成しはじめました。: " + this.sampleNumber);
      // 任意のsampleDataを作成する
      for (let index = 0; index < this.sampleNumber; index++) {
        const _id = Math.random().toString(32).substring(2);
        const data = {
          id: _id,
          appId: _id,
          time: new Date()
        }
        this.sampleData.push(data);   
      }

      // sampleDataをlightDataに突っ込む
      this.sampleData.forEach(element => {
        this.lightData.push(element);
      });
      console.log(new Date()  + " , " + new Date().getTime() +  " :Visualization.vue:: Finish preparation sample Data / サンプルデータを準備が完了しました。: " + this.sampleNumber);
    },

    moveSampleData: function () {
      this.sampleData.forEach(element => {
        const randomTime = Math.floor(Math.random()*(800-600)+600);
        setInterval(this.lightSampleData, randomTime, element);
      });
    },

    lightSampleData: function(data) {
      const _id = Math.random().toString(32).substring(2);
      data.id = _id;
      this.modifyLightData(data);
    },

    realTimeCheck: function() {
      this.db.collection('kodou-timing').where('timing-local', '>=', this.launchedTimestamp)
        .onSnapshot(querySnapshot => {
          for (let change of querySnapshot.docChanges()) {
            if (change.type === 'added') {
                // データが追加された時
                let data = {
                  id: change.doc.id,
                  appId: change.doc.data()['app-id'],
                  time: new Date()
                };
                let timengLocalDate = change.doc.data()['timing-local'].toDate();
                let logDate = new Date();
                console.log(logDate + "," + logDate.getTime() + "," + timengLocalDate + "," + timengLocalDate.getTime() + "," + change.doc.data()['app-id']);
                this.modifyLightData(data);
            }
          }
        })
    },

    modifyLightData: function(data){
      // console.log(this.count++);

      let index = -1;
      if (data.appId in this.idHash) {
        index = this.idHash[data.appId];
      } else {
        index = this.lightData.findIndex(d => d.appId == data.appId);
      }

      if (index === -1) {
        this.idHash[data.appId] = this.lightData.length;
        this.lightData.push(data);
      } else {
        // 500ms以内に来たものはデータの入れ替えを行わない
        if ((data.time - this.lightData[index].time) > 550) {
          this.$refs[`light${index}`].showLight();
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

#flex {
  display: flex;
  flex-wrap: wrap;
}

.lightContainer {
  width: 4px;
  height: 4px;  
  margin: 22px;
}

</style>
